angular
  .module 'memberPortal'
  .controller 'MembershipCtrl', (
    $scope,
    $stateParams,
    $filter,
    DataService,
    membership
  ) ->
    $scope.data = DataService
    $scope.hash = $stateParams.m
    $scope.membership = membership

    $scope.getHash = ->
      $stateParams.hash || $stateParams.m
